import React from 'react'
import { $Treatment } from '../shared-consumer/stores/TreatmentStore/TreatmentModel'
import { Typography, Box, Divider, withStyles, createStyles, Grid, Chip, WithStyles } from '@material-ui/core'
import TextButton from './TextButton'
import { CategoryViewModel } from '../pagesModels/ViewCategoryViewModel'
import { currencyFormat } from '../shared-lib/currency'
import { inject } from 'mobx-react'
import { theme } from '../theme'
import RootStore from '../src/stores/RootStore'
import { userFirstName } from '../shared-consumer/lib/utils'
import { getElitePriceToDisplayForTreatment } from '../shared-lib/eliteProfessionalHelpers'
import Image from 'next/image'

interface CategoryTreatmentsProps extends WithStyles<typeof styles> {
  treatments: Array<$Treatment & { comingSoon: boolean, lowAvailability: boolean }>
  viewModel: Pick<CategoryViewModel, 'viewTreatment'>
  store?: Pick<RootStore, 'i18n' | 'checkoutStore' | 'uiStore'>
}

const styles = () => createStyles({
  treatmentsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4),
      marginTop: theme.spacing(-2),
    },
  },
  treatment: {
    marginTop: theme.spacing(6),
    cursor: 'pointer',
  },
})

const CategoryTreatments = (props: CategoryTreatmentsProps) => {
  const {
    treatments,
    classes,
    viewModel,
    store,
  } = props
  const {
    i18n: { s },
    checkoutStore: { provisionalProfessional, hasEliteProfessional },
    uiStore: { showRemoveProfessionalPopup },
  } = store!
  const { viewTreatment } = viewModel

  return <Box>
    {treatments && treatments.length === 0 && provisionalProfessional &&
      <Box
        display={'flex'}
        alignItems={'center'}
        flexDirection={'column'}
        justifyContent={'center'}
        pt={8}
        width={'100%'}
      >
        <Typography align='center'>
          {s('PRO_UNCOVERED_TREATMENT', userFirstName(provisionalProfessional))}
        </Typography>

        <Box mt={2} />

        <TextButton onClick={showRemoveProfessionalPopup}>
          {s('Remove $0 from booking', userFirstName(provisionalProfessional))}
        </TextButton>
      </Box>
    }

    <Grid className={classes.treatmentsContainer}>
      {treatments?.map((treatment, index: number) => {
        const { _id, name, shortDescription, price, comingSoon, lowAvailability } = treatment
        let displayPrice = price

        if (hasEliteProfessional) {
          displayPrice = getElitePriceToDisplayForTreatment(treatment._id, price)
        }

        return (
          <Grid
            item
            xs={12}
            key={_id}
            className={classes.treatment}
            onClick={() => !comingSoon && viewTreatment(_id)}
            style={{ pointerEvents: comingSoon ? 'none' : 'all' }}
          >
            <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
              <Box maxWidth={'85%'}>
                <Box mb={2}>
                  <Typography variant='h4'>{name}</Typography>
                </Box>

                <Typography variant='body1' gutterBottom>{shortDescription}</Typography>

                <Box mt={2} display='flex' alignItems={'center'}>
                  <Typography variant='body2'>
                    {s('From ')}{currencyFormat(displayPrice)}
                  </Typography>

                  {comingSoon && <Chip color='secondary' size='small' label={s('Coming soon')} />}

                  {lowAvailability && <Box ml={2}>
                    <Chip size='small' label={s('Limited availability')} />
                  </Box>}
                </Box>
              </Box>

              {!comingSoon && <>
                <Box mr={2}>
                  <Image src={'/img/icons/forward.png'} height={25} width={12} />
                </Box>
              </>}
            </Box>

            {index !== (treatments.length - 1) &&
              <Box mx={0} mt={6}>
                <Divider />
              </Box>
            }
          </Grid>
        )
      })}
    </Grid>
  </Box>
}

export default withStyles(styles)(inject('store')(CategoryTreatments))
